import type { ProductConfig } from '../../@types/context/product-config.types';

export const productConfigNo: ProductConfig = {
  availableProducts: [
    'unsecured-loan',
    'credit-card',
    'secured-loan',
    'insurance',
  ],
};

export const productConfigLimited: ProductConfig = {
  availableProducts: ['unsecured-loan', 'insurance'],
};

export const productConfigFi: ProductConfig = {
  availableProducts: ['unsecured-loan', 'credit-card', 'insurance'],
};
